<template>
  <!-- rn === rollnotice -->
  <div class="rn-box">
    <p>{{num}} Exhibitors</p>
    <!-- <i class="iconfont icon-laba"></i>
    <div class="rn-box-l">
        <van-notice-bar  :scrollable="false">
            <van-swipe
                vertical
                class="notice-swipe"
                :autoplay="3000"
                :show-indicators="false"
            >
                <van-swipe-item>已有{{num}}家展商发布</van-swipe-item>
            </van-swipe>
        </van-notice-bar>
    </div> -->
  </div> 
</template>

<script>
import { mapGetters } from 'vuex' 
export default { // 滚动提示
  name: "rollnotice",
  props:['num'],
  data() {
    return { 
      statisticsData: null,
      ViewCount: null,
      ExhibitorCount: null,
      Help: null,
      timer: null,
    };
  },
  created() {
  },
  computed: {
  }, 
  methods: { 
  },
};
</script>

<style scoped lang='scss'>
.rn-box{
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0.24rem;
    // height: 0.7rem;
    align-items: center;
    margin-top: 0.3rem;
    // background: #fff;
    color: #666;
    font-size: 0.24rem;
    // box-shadow: 0px 3px 5px 0px rgba(171, 170, 170, 0.33);
    i{
        color: #0190fe;
        transform: scale(1.5);
        margin-right: 0.18rem;
        vertical-align: middle;
    }
    &-l{
        flex:1;
        height: .7rem;
        .van-notice-bar{
            height: 100%;
            background: #fff;
            padding: 0;
            color: #666;
            .notice-swipe {
                height: 24px;
                line-height: 24px;
            }
            .van-swipe-item{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 5rem;
            }
        }
    }

}
</style> 